var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "ruleForm",
      staticClass: "demo-ruleForm",
      attrs: { "label-position": "top" },
    },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("newOrder.SenderName") } },
                [
                  _c("encryption-field", {
                    attrs: {
                      "field-name": "senderName",
                      "encrypted-value": _vm.ruleForm.senderName,
                      label: _vm.$t("newOrder.SenderName"),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("newOrder.SenderCompany") } },
                [
                  _c("encryption-field", {
                    attrs: {
                      "field-name": "senderCompany",
                      "encrypted-value": _vm.ruleForm.senderCompany,
                      label: _vm.$t("newOrder.SenderCompany"),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("newOrder.senderPhone") } },
                [
                  _c("encryption-field", {
                    attrs: {
                      "field-name": "senderMobile",
                      "encrypted-value": _vm.ruleForm.senderMobile,
                      label: _vm.$t("newOrder.senderPhone"),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("driver.modalStreet") } },
                [
                  _c("encryption-field", {
                    attrs: {
                      "field-name": "senderStreet",
                      "encrypted-value": _vm.ruleForm.senderStreet,
                      label: "senderStreet",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("newOrder.SenderNumber") } },
                [
                  _c("encryption-field", {
                    attrs: {
                      "field-name": "senderHouseNumber",
                      "encrypted-value": _vm.ruleForm.senderHouseNumber,
                      label: "senderHouseNumber",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("newOrder.SenderDistrict") } },
                [
                  _c("encryption-field", {
                    attrs: {
                      "field-name": "senderArea",
                      "encrypted-value": _vm.ruleForm.senderArea,
                      label: "senderArea",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("newOrder.SenderCity") } },
                [
                  _c("encryption-field", {
                    attrs: {
                      "field-name": "senderCity",
                      "encrypted-value": _vm.ruleForm.senderCity,
                      label: "senderCity",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("newOrder.SenderState") } },
                [
                  _c("encryption-field", {
                    attrs: {
                      "field-name": "senderState",
                      "encrypted-value": _vm.ruleForm.senderState,
                      label: "senderState",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("newOrder.SenderZipCode") } },
                [
                  _c("encryption-field", {
                    attrs: {
                      "field-name": "senderZipcode",
                      "encrypted-value": _vm.ruleForm.senderZipcode,
                      label: "senderZipcode",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("GlobalSetObj.sendderComplement") } },
                [
                  _c("encryption-field", {
                    attrs: {
                      "field-name": "senderComplement",
                      "encrypted-value": _vm.ruleForm.senderComplement,
                      label: _vm.$t("GlobalSetObj.sendderComplement"),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("newOrder.SenderCPF") } },
                [
                  _c("encryption-field", {
                    attrs: {
                      "field-name": "senderTax",
                      "encrypted-value": _vm.ruleForm.senderTax,
                      label: _vm.$t("newOrder.SenderCPF"),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("navbar.senderIe") } },
                [
                  _c("encryption-field", {
                    attrs: {
                      "field-name": "senderIeNumber",
                      "encrypted-value": _vm.ruleForm.senderIeNumber,
                      label: "senderIeNumber",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("newOrder.SendingAddress") } },
                [
                  _c("encryption-field", {
                    attrs: {
                      "field-name": "senderAddress",
                      "encrypted-value": _vm.ruleForm.senderAddress,
                      label: _vm.$t("newOrder.SendingAddress"),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("newOrder.SenderPhone") } },
                [
                  _c("encryption-field", {
                    attrs: {
                      "field-name": "senderPhone",
                      "encrypted-value": _vm.ruleForm.senderPhone,
                      label: _vm.$t("newOrder.SenderPhone"),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("newOrder.SenderEmail") } },
                [
                  _c("encryption-field", {
                    attrs: {
                      "field-name": "senderMail",
                      "encrypted-value": _vm.ruleForm.senderMail,
                      label: _vm.$t("newOrder.SenderEmail"),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }